/** Viewport width at or above this uses centered, roomier auth layout (tablet / desktop). */
export const AUTH_SCREEN_LARGE_MIN_WIDTH = 768;

/**
 * On large-width layouts, only vertically center when the window is at least this tall.
 * Shorter viewports (landscape tablet, small desktop window, split screen) stay bottom-anchored
 * so the card/sheet remains reachable and consistent with phone behavior.
 */
export const AUTH_SCREEN_LARGE_CENTER_MIN_HEIGHT = 640;

/** Auth column max width on compact viewports (phones). */
export const AUTH_SCREEN_COLUMN_MAX_WIDTH_COMPACT = 430;

/** Auth column max width on large viewports — slightly wider card on big screens. */
export const AUTH_SCREEN_COLUMN_MAX_WIDTH_LARGE = 440;

/**
 * Extra top padding on large auth layouts. Kept moderate so short laptop viewports still fit
 * the monkey + card without clipping when the column is bottom-anchored (short viewport height).
 */
export const AUTH_SCREEN_EXTRA_TOP_PADDING = 56;

/** Bottom padding inside the auth frame (compact); keep modest so bottom-anchored content sits low. */
export const AUTH_SCREEN_PADDING_BOTTOM_COMPACT = 0;

/** Bottom padding inside the auth frame (large viewports). */
export const AUTH_SCREEN_PADDING_BOTTOM_LARGE = 12;
